
export default {
	history: [
		{
			date: "2017/11/03",
			content: [
				"{{RatioCalc}} 爆誕"
			]
		},
		{
			date: "2017/09/18",
			content: [
				"Codogue.comをリニューアルしました",
				"全てのアプリが作り直されました",
				"{{Facebookmark}} 消滅"
			]
		},
		{
			date: "2015/03/17",
			content: "{{DataURI}} 爆誕"
		},
		{
			date: "2013/10/28",
			content: "{{Zen2Han}} 爆誕"
		},
		{
			date: "2013/09/06",
			content: [
				"Codogue.comをリニューアルしました",
				"{{Facebookmark}} 爆誕"
			]
		},
		{
			date: "2013/03/22",
			content: [
				"Twitterのサービス変更に伴い{{Twhois}}消滅",
				"{{MultiMentions}}からツイートボタンを削除"
			]
		},
		{
			date: "2012/09/05",
			content: "{{AsciiTree}} 爆誕"
		},
		{
			date: "2012/06/06",
			content: "{{GridCalc}} 爆誕"
		},
		{
			date: "2011/10/14",
			content: [
				"{{TsvTo}} 消滅",
				"{{Twhois}} 爆誕"
			]
		},
		{
			date: "2011/02/08",
			content: [
				"Codogue.comリリース",
				"{{TsvTo}} 爆誕",
				"{{Mkpasswd}} 爆誕"
			]
		}
	]
}



// WEBPACK FOOTER //
// ./src/js/json/history.js